<div class="list-wrapper">
  <div class="header">
    <div class="header-left">
      <!-- <span>Unread</span> -->
      &nbsp;
      <kendo-switch
        class="medium-switch"
        [onLabel]="'Unread'"
        [offLabel]="'Read'"
        [(ngModel)]="showOnlyUnread"></kendo-switch>
    </div>
    <div class="header-actions" kendoTooltip>
      <div class="header-action">
        <span
          class="k-icon k-font-icon k-i-check-outline icon-button icon-button-mark-all"
          title="Mark all as read"
          (click)="markAllAsRead()"></span>
      </div>
      <div class="header-action">
        <span
          class="k-icon k-font-icon k-i-hyperlink-open-sm icon-button"
          [hidden]="!canShowOpenSelected()"
          title="Display work items"
          (click)="openSelected()"></span>
      </div>
      <div class="header-action">
        <span
          class="k-icon k-font-icon k-i-delete k-i-trash icon-button"
          [hidden]="!canShowOpenSelected()"
          title="Delete selected notifications"
          (click)="deleteSelected()"></span>
      </div>
      <div class="header-action">
        <input
          class="notification-selector"
          type="checkbox"
          kendoCheckBox
          [indeterminate]="someSelected()"
          [checked]="globalSelection"
          (change)="globalSelectionChanged()" />
      </div>
    </div>
  </div>

  <div class="body">
    <kendo-listview
      #listView
      class="notifications-list"
      containerClass="k-d-flex k-flex-col k-flex-nowrap"
      [data]="filteredNotifications"
      [navigable]="true"
      (scrollBottom)="loadMore($event)">
      <ng-template
        kendoListViewItemTemplate
        let-dataItem="dataItem"
        let-isFirst="isFirst">
        <app-notifications-list-item-work-item
          [notification]="dataItem"
          (selectionChanged)="onSelectionChanged()"
          (deleteClick)="onDelete(dataItem)"
          (itemClick)="markAsRead(dataItem)"
          (navigateClick)="
            openWorkItem(dataItem)
          "></app-notifications-list-item-work-item>
      </ng-template>
    </kendo-listview>
  </div>

  <div class="footer">
    <div class="footer-left">
      @if (statisticsSlice()) {
        <span>
          {{ statisticsSlice().totalUnread }} / {{ statisticsSlice().total }}
        </span>
      }
    </div>
    <div class="footer-actions">
      <span
        class="k-icon k-font-icon k-i-arrow-up icon-button"
        (click)="scrollToTop()"></span>
    </div>
  </div>
</div>
